import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import SocketProvider from 'socket/socketProvider';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import { ApolloProvider } from '@apollo/client';
import { client } from 'graphql/apolloClient';
import { AuthProvider } from 'customHook/useAuth';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallbackScreen from 'screens/ErrorFallbackScreen';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ApolloProvider client={client}>
          <AuthProvider>
            <SocketProvider url={process.env.REACT_APP_SOCKET_URL}>
              <ErrorBoundary
                FallbackComponent={ErrorFallbackScreen}
                onReset={() => window.location.reload()}
              >
                <App />
              </ErrorBoundary>
            </SocketProvider>
          </AuthProvider>
        </ApolloProvider>
      </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);